import { IconClock } from '@calendly/ui/components/glyphs/IconClock'

import { PANELS } from 'constants/event_type_editor_panels'
import {
  getAvailabilityInitialValues,
  getAvailabilityValidationSchema,
  getFormatAvailabilityValues,
} from 'features/event_type_editor'

export const AVAILABILITY_TAB_KEY = 'availability'

export const getValidationSchema = getAvailabilityValidationSchema

export const getInitialValues = (eventType, defaultAvailabilityRules) => (
  getAvailabilityInitialValues({ eventType, defaultAvailabilityRules })
)

export const getFormatValuesToServerData = getFormatAvailabilityValues

const getPanelFieldNames = () => Object.keys(getValidationSchema().fields)

export const getPanelFieldNamesForErrorRollup = getPanelFieldNames

export const availabilityTabDefinition = {
  key: AVAILABILITY_TAB_KEY,
  label: 'Availability',
  icon: IconClock,
  subtitle: 'Working hours',
  formKey: 'eventDetails',
  panelKeys: [PANELS.availability],
  usesCustomPanel: true,
}

export const getAvailabilityActiveTabConfig = (eventType) => ({
  fieldNames: getPanelFieldNamesForErrorRollup(),
  validationSchema: getValidationSchema(),
  formatPanelKeys: [PANELS.availability],
  formatValuesToServerData: getFormatValuesToServerData(eventType),
})
